import { Box, Grid2, Show, ThemeProvider } from "components";
import { useFormContext } from "react-hook-form";
import { useAppSelector } from "store/store";
import { ThemeContainer } from "utils/Theme";
import PreviewFrame from "../PreviewFrame";
import { WebsiteDetails } from "../types";
import AboutMeSection from "./AboutMeSection";
import BasketListSection from "./BasketListSection";
import FaqsSection from "./FaqsSection";
import FooterSection from "./FooterSection";
import HeroSection from "./HeroSection";
import PerformanceMetricsSection from "./PerformanceMetricsSection";
import QuoteSection from "./QuoteSection";
import TestimonialsSection from "./TestimonialsSection";
import WebsiteHeader from "./WebsiteHeader";

const Preview = () => {
  const form = useFormContext<WebsiteDetails>();

  const { theme } = ThemeContainer();

  const previewMode = useAppSelector((state) => state.myWebsite.previewMode);
  const selectedSection = useAppSelector(
    (state) => state?.myWebsite?.selectedSection,
  );

  const width = {
    desktop: "100%",
    tablet: 768,
    mobile: 375,
  }[previewMode];

  const shouldShow = (section: string) =>
    selectedSection === section ||
    selectedSection === "MY_BRANDING" ||
    selectedSection === null;

  return (
    <PreviewFrame width={width}>
      <ThemeProvider
        theme={{
          ...theme,
          palette: {
            ...theme.palette,
            primary: {
              main: form.watch(
                "websiteSection.myBranding.colorPalette.primary",
              ),
              contrastText: "#FFFFFF",
            },
            secondary: {
              main: form.watch(
                "websiteSection.myBranding.colorPalette.secondary",
              ),
            },
          },
        }}
      >
        <Grid2 container position={"relative"}>
          <Show.When isTrue={shouldShow("MY_BRANDING")}>
            <Box px={{ xs: 3, md: 10 }} width={"100%"} bgcolor={"var(--white)"}>
              <WebsiteHeader />
            </Box>
          </Show.When>

          <Show.When isTrue={shouldShow("HERO_SECTION")}>
            <Grid2
              size={12}
              bgcolor={"#F8F8F8"}
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
              py={{ xs: 2, md: 10 }}
              px={{ xs: 2, md: 10 }}
            >
              <HeroSection />
            </Grid2>
          </Show.When>

          <Show.When isTrue={shouldShow("PERFORMANCE_METRICS")}>
            <Grid2
              size={12}
              bgcolor={"var(--white)"}
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
              py={{ xs: 2, md: 10 }}
              px={{ xs: 2, md: 10 }}
            >
              <PerformanceMetricsSection />
            </Grid2>
          </Show.When>

          <Show.When isTrue={shouldShow("QUOTE_MANTRA")}>
            <Grid2
              size={12}
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
              py={{ xs: 2, md: 10 }}
              px={{ xs: 2, md: 10 }}
              bgcolor={"#20272A"}
              sx={{
                backgroundImage: `radial-gradient(#ffffff22 1px, transparent 1px)`,
                backgroundSize: "20px 20px",
              }}
            >
              <QuoteSection />
            </Grid2>
          </Show.When>

          <Show.When isTrue={shouldShow("MY_BASKETS")}>
            <Grid2
              size={12}
              display={"flex"}
              justifyContent={"center"}
              bgcolor={"#fff"}
              alignItems={"center"}
              py={{ xs: 2, md: 10 }}
              px={{ xs: 2, md: 10 }}
            >
              <BasketListSection />
            </Grid2>
          </Show.When>

          <Show.When isTrue={shouldShow("ABOUT_ME")}>
            <Grid2
              size={12}
              display={"flex"}
              justifyContent={"center"}
              bgcolor={"#F7FBFD"}
              alignItems={"center"}
              py={{ xs: 2, md: 10 }}
              px={{ xs: 2, md: 10 }}
            >
              <AboutMeSection />
            </Grid2>
          </Show.When>

          <Show.When isTrue={shouldShow("TESTIMONIALS")}>
            <Grid2
              size={12}
              display={"flex"}
              justifyContent={"center"}
              bgcolor={"#F7FBFD"}
              alignItems={"center"}
              py={{ xs: 2, md: 10 }}
              px={{ xs: 2, md: 10 }}
            >
              <TestimonialsSection />
            </Grid2>
          </Show.When>

          <Show.When isTrue={shouldShow("FAQS")}>
            <Grid2
              size={12}
              display={"flex"}
              justifyContent={"center"}
              bgcolor={"#F7FBFD"}
              alignItems={"center"}
              py={{ xs: 2, md: 10 }}
              px={{ xs: 2, md: 10 }}
            >
              <FaqsSection />
            </Grid2>
          </Show.When>

          <Show.When isTrue={shouldShow("FOOTER")}>
            <Grid2
              size={12}
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
              border={"solid 1px var(--neutral-100)"}
              py={{ xs: 2, md: 10 }}
              px={{ xs: 2, md: 10 }}
            >
              <FooterSection />
            </Grid2>
          </Show.When>
        </Grid2>
      </ThemeProvider>
    </PreviewFrame>
  );
};

export default Preview;
